import { Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';

@Injectable()
export class RoutesForPacking extends RoutePathBuilder {
    queue() {
        return this.url('');
    }

    pack() {
        return this.url('perform');
    }
}
